import SC from 'styled-components'

export const ItemWrapper = SC.div`
  width: 226px;
`
